import { render, staticRenderFns } from "./border.vue?vue&type=template&id=415f0af0&scoped=true"
import script from "./border.vue?vue&type=script&lang=js"
export * from "./border.vue?vue&type=script&lang=js"
import style0 from "./border.vue?vue&type=style&index=0&id=415f0af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f0af0",
  null
  
)

export default component.exports